
import axios from "axios";
import { useEffect, useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import DataTable from "react-data-table-component";
import { Link, useParams } from "react-router-dom";
import SidebarAdmin from "./SidebarAdmin";
import '../styles/videodata.css'
import SidebarAdminMain from "./SidebarAdminMain";
import { BASE_URL, tableCustomStyles } from "../App";


function ShowLevelHomework() {
  
  const {id} = useParams()
  const [homework , setHomework] = useState([]);
  
  const axiosInstance = axios.create({
    baseURL: `${BASE_URL}`,
    headers: {
        'Content-Type': 'application/json',
        "ngrok-skip-browser-warning": "any",
    },
});



const getLevelHomework = async () => {
    try {
      const token = localStorage.getItem('token' );
      const response = await axiosInstance.get(`/api/show-level-homeworks/${id}` , {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        // console.log(response.data.data.map(item => item.id))
        // console.log(response.data.data);
        setHomework(response.data.data)
        // setFilteredData(response.data.data);
        const data = response.data.data;
                 return data;
    } catch (error) {
        // console.log(error);
    }
}

useEffect (() =>{
    getLevelHomework();
}, [])






const [rows, setRows] = useState([]);

const deleteRow = async(id, token) => {
  try {
      const response = await axios.delete(`${BASE_URL}/api/homeworks/${id}`, {
          headers: {
              Authorization: `Bearer ${token}`,
          },
      });
  } catch (error) {
      // console.error(error);
  }

};
const handleDeleteClick = async (id) => {
  const token = localStorage.getItem('token' );
  try {
      await deleteRow(id, token);
      const updateQuestion = homework.filter(row => row.id !== id);
      setHomework(updateQuestion);
  } catch (error) {
      // console.error(error);
  }
};





const [filteredData, setFilteredData] = useState([]);
const [searchTerm, setSearchTerm] = useState("");

const handleSearch = (e) => {
  setSearchTerm(e.target.value);
  const searchResults = homework.filter((item) => {
    return (
      item.attributes.title.toLowerCase().includes(e.target.value.toLowerCase()) |
      item.attributes.level.toLowerCase().includes(e.target.value.toLowerCase()) 
    );
  });
  setFilteredData(searchResults);
};







  
    const columns = [
 
      {
        name: "ID ",
        selector: (row) => row.id,
        sortable : true,
      //   style: {
      //     background: "#e6e6e6",
      //   }
      // grow:2,
      },
      {
        name: "Week_ID ",
        selector: (row) => row.attributes.week_id,
        sortable : true,
      //   style: {
      //     background: "#e6e6e6",
      //   }
      // grow:2,
      },
      {
        name: "Title ",
        selector: (row) => row.attributes.title,
        sortable : true,
      //   style: {
      //     background: "#e6e6e6",
      //   }
      grow:2,
      },
      {
        name: "Degree ",
        selector: (row) => row.attributes.degree,
        sortable : true,
      //   style: {
      //     background: "#e6e6e6",
      //   }
      // grow:2,
      },
      {
        name: "Level ",
        selector: (row) => row.attributes.level,
        sortable : true,
      //   style: {
      //     background: "#e6e6e6",
      //   }
      // grow:2,
      },
      {
        name: "Created_At ",
        selector: (row) => row.attributes.created_at,
        sortable : true,
      //   style: {
      //     background: "#e6e6e6",
      //   }
      grow:2,
      },
      {
        name: "Updated_At ",
        selector: (row) => row.attributes.updated_at,
        sortable : true,
      //   style: {
      //     background: "#e6e6e6",
      //   }
      grow:2,
      },
  
      {
        name: "Edit",
        cell: row => <button style={{background:"#28a745" , border: "none"}} className="btn btn-success pe-3 ps-3 pt-2 pb-2">Edit</button>,

        
      },
      {
        name: "Student",
        cell: row => <button style={{background:"#" , border: "none"}} className="btn btn-primary pe-lg-3 ps-lg-3 ps-1 pe-1 pt-2 pb-2">Student</button>,
          grow:2
        
      },
      {
        name: "Delete",
        cell: row => <button style={{background:"#" , border: "none"}} className="btn btn-danger pe-lg-3 ps-lg-3 ps-2 pe-2 pt-2 pb-2" onClick={() => alert('هل انت متأكد من حذف هذا الواجب') | handleDeleteClick(row.id)}>Delete</button> ,
        grow:2,
    },
     
    ];

    
    return (
        <>
      <div className="d-flex">
    
       <div className="video-data">
      
      <div className="main-title">  بيانات الواجبات  </div>
    
      <Container>
    
          <Row>
         
          <Col lg={12}>
                     <div className="quiz-content">
              <DataTable
                                           customStyles={tableCustomStyles}

               columns={columns}
               data={filteredData.length > 0 ? filteredData : homework} 
                pagination 
                fixedHeader
                // selectableRows
                // fixedHeaderScrollHeight="400px"
                highlightOnHover
                actions={
                  <Link to="/admin/addhomework">
                                       <button className="btn btn-primary mt-4 mb-4 fs-5 fw-bold pt-2 pb-2 pe-4 ps-4 me-2">اضافة واجب</button>   
                  </Link>
               }
                subHeader
                subHeaderComponent={
                  <input type="text" className="form-control mt-4 mb-4" placeholder="Search of Homework" onChange={handleSearch} />

                }
                />
              </div>
                                          </Col>
          </Row>
      </Container>

    
      </div>
      <div className="sidebar">
       <SidebarAdminMain />
       </div>
       </div>
        </>
    )
}

export default ShowLevelHomework;